/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Option } from './option';


export interface QuestionDto { 
    id: string;
    /**
     * Internationalized text that resolves to a string
     */
    preTitle?: string;
    /**
     * Internationalized text that resolves to a string
     */
    title: string;
    /**
     * Internationalized text that resolves to a string
     */
    description: string;
    type: QuestionDto.TypeEnum;
    options: Array<Option>;
    /**
     * Internationalized text that resolves to a string
     */
    neverDoText: string;
    /**
     * Internationalized text that resolves to a string
     */
    infoTips?: string;
    nesteds?: Array<QuestionDto>;
    value?: object;
    scoreReferId?: string;
    placeholder?: string;
    suffix?: string;
    /**
     * Internationalized text that resolves to a string
     */
    answerSentence?: string;
}
export namespace QuestionDto {
    export type TypeEnum = 'yesno' | 'select' | 'multi' | 'text' | 'number' | 'float' | 'time' | 'choiceAnswer';
    export const TypeEnum = {
        Yesno: 'yesno' as TypeEnum,
        Select: 'select' as TypeEnum,
        Multi: 'multi' as TypeEnum,
        Text: 'text' as TypeEnum,
        Number: 'number' as TypeEnum,
        Float: 'float' as TypeEnum,
        Time: 'time' as TypeEnum,
        ChoiceAnswer: 'choiceAnswer' as TypeEnum
    };
}


